<template>
	<div class="col-md-12">
		<div class="form-group">
			<div v-if="getSystemSetting('resource__file_upload')" class="upload-field-box__content">
				<VueFilePond name="file" ref="resourcePond" label-idle="Drop files here or Click to select files"
					fileValidateTypeLabelExpectedTypes="Expects pdf,images,videos,zip,document formats."
					:accepted-file-types="[
						'image/*',
						'video/*',
						'application/pdf',
						'application/zip', 'application/x-zip', 'application/x-zip-compressed',
						'text/plain', 'text/csv', 'application/vnd.oasis.opendocument.text',
						'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
						'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.spreadsheet',
						'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.oasis.opendocument.presentation'
					]" :max-file-size="'25MB'" :allow-multiple="true" :allowRemove="true" :allowRevert="false" :allowReorder="true"
					:allowProcess="false" :instantUpload="false" :dropOnElement="true" :dropOnPage="true"
					:dropValidation="true" :files="filepond" :checkValidity="true" />
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<button class="btn btn-primary" type="button" @click="saveFn" data-dismiss="modal">Upload</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
const VueFilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginFileValidateSize
);
export default {
	props: {
		linkUrl: Object,
		linkLabel: Object,
		linkNotes: Object,
		linkType: Object,
		isFile: Boolean,
		resourceParent: String,
		namespace: String,
	},
	components: {
		VueFilePond,
	},
	data() {
		return {
			filepond: [],
		};
	},
	computed: {
		...mapState({
			state(state) {
				return state[this.namespace]
			},
			deliverableDetail(state, getters) {
				return getters[this.namespace + 'deliverableDetail']
			},
			allCustomFields(state, getters) {
				return getters[this.namespace + 'allCustomFields']
			},
		}),
		...mapGetters([
			"getSystemSetting",
			"projectDetail",
		]),
		apiUrl() {
			return process.env.MIX_API_BASE_URL;
		},
		optionsForLinkType() {
			const linkTypeField = this.allCustomFields.find(x => x.id == 37);
			return JSON.parse(linkTypeField.value_set);
		},
	},
	methods: {
		...mapMutations([
			"setDataLoading",
			"setDeliverable",
			"setDeliverableDetail",
			"setProjectDetail",
		]),
		getOptionObject(id) {
			return this.optionsForLinkType.find(x => x.id == id);
		},
		saveFn() {
			// allow multiple files in single save
			let endPoint;
			if (this.resourceParent == "deliverable") {
				endPoint = "uploadFileDeliverable";
			} else if (this.resourceParent == "project") {
				endPoint = "uploadFileProject";
			}
			if (endPoint) {
				this.setDataLoading(true);
				const files = this.$refs.resourcePond._pond.getFiles();
				const formData = new FormData();

				files.forEach(fileItem => {
					formData.append('files[]', fileItem.file, fileItem.file.name);
				});

				if (this.resourceParent == "deliverable") {
					formData.append('id', this.deliverableDetail.id);
				} else if (this.resourceParent == "project") {
					formData.append('id', this.projectDetail.id);
				}

				axios.post(`${this.apiUrl}${endPoint}`, formData)
					.then(response => {
						// Handle successful response
						if (response.data) {
							if (this.resourceParent == "deliverable") {
								this.setDeliverable(response.data.deliverableDetail);
								this.setDeliverableDetail(response.data.deliverableDetail);
							} else if (this.resourceParent == "project") {
								this.setProjectDetail(response.data.projectDetail);
							}
						}
						this.setDataLoading(false);
						if (this.resourceParent == "deliverable") {
							this.$bvModal.hide('createLinkModal');
						} else if (this.resourceParent == "project") {
							this.$bvModal.hide('createProjectLinkModal');
						}
					})
					.catch(error => {
						this.setDataLoading(false);
						Object.keys(error.errors).forEach(key => {
							const index = key.match(/\d+/)[0];
							const fileItem = this.$refs.resourcePond._pond.getFiles()[index];
							this.applyErrorStyle(fileItem, error.errors[key]);
						});
					});
			} else {
				console.error("endPoint undefined")
			}
		},
		applyErrorStyle(fileItem, errorMessages) {
			const fileItemElement = document.querySelector(`#filepond--item-${fileItem.id}`);
			fileItemElement.setAttribute('data-filepond-item-state', 'error');
			if (fileItemElement) {
				const fieldset = fileItemElement.querySelector('.filepond--file-wrapper .filepond--file .filepond--file-status');
				if (fieldset) {
					fieldset.style.visibility = 'visible';
					fieldset.style.opacity = '1';
					const spanMain = fieldset.querySelector('span.filepond--file-status-main');
					if (spanMain) {
						spanMain.textContent = 'Invalid File';
					}
					const spanSub = fieldset.querySelector('span.filepond--file-status-sub');
					if (spanSub) {
						let validationErrors = errorMessages.flat().join(' ');
						spanSub.textContent = validationErrors;
					}
				}
			}
		},
	},
};
</script>

<style>
.upload-field-box__content {
	background-color: var(--wf-secondary);
	border: 1px solid #bfbfbf;
	padding: 10px;
	border-radius: 10px;
}
</style>